module.exports = __webpack_public_path__ + "img/gotop.41966f88.png";